import { KeyBy } from "@m7-health/shared-utils";

import { IStaffType } from "@/api";
import { useAppSelector } from "@/common/hooks";

export const useStaffTypes = () => {
  return useAppSelector((state) => state.appConfig.staffType.staffTypes);
};

export function useStaffTypeByKey(): KeyBy<IStaffType, "key">;
export function useStaffTypeByKey(key: IStaffType["key"] | undefined): IStaffType | undefined;
export function useStaffTypeByKey(
  key?: IStaffType["key"],
): KeyBy<IStaffType, "key"> | IStaffType | undefined {
  const staffTypeByKey = useAppSelector((state) => state.appConfig.staffType.staffTypeByKey);

  if (arguments.length === 0) return staffTypeByKey;

  // If a value is explicitly provided, even if it's undefined, return one value
  if (key) return staffTypeByKey[key];
  return undefined;
}
